module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Apple_01.08b89281.png";